<template>
  <v-app>
    <v-main>
      <v-container fluid v-if="isTrue">
        <v-form v-if="!isCalendar">
          <v-row>
            <v-col>
              <v-autocomplete
                :items="modals"
                v-model="selectModal"
                outlined
                item-text="title"
                label="Специализация"
                clearable
                hide-details
                color="primary"
                @change="getMedicinesToModals"
              >
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs" :input-value="data.selected">
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-select
                :items="branch"
                v-model="selectBranch"
                outlined
                item-text="LABEL"
                item-value="FM_INTORG_ID"
                label="Филиал"
                multiple
                hide-details
                color="primary"
                clearable
              >
              </v-select>
            </v-col>
            <v-col>
              <v-select
                :items="status"
                v-model="selectStatus"
                outlined
                item-text="TITLE"
                item-value="ID"
                label="Статус"
                hide-details
                color="primary"
                clearable
              >
              </v-select>
            </v-col>
            <v-col>
              <v-autocomplete
                :items="medicines"
                v-model="selectMedicine"
                outlined
                multiple
                item-text="ФИО"
                item-value="Ид"
                label="Врач"
                hide-details
                color="primary"
                placeholder="Начните вводить..."
                no-data-text="Ничего не найдено"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="openMedicine(data.item)"
                    @click:close="remove(data.item, 'medicine')"
                  >
                    {{ data.item.ФИО }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="selectedPacient"
                :items="pacients"
                :search-input.sync="searchPacient"
                item-text="name"
                item-value="id"
                label="Пациент"
                outlined
                hide-details
                color="primary"
                clearable
                placeholder="ФИО или телефона"
                no-data-text="Ничего не найдено"
                @update:search-input="onInput"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    @click="openPacient(data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <div>
                    <strong>{{ item.name }}</strong>
                    <div class="text-caption text--secondary">
                      {{ item.phone }}
                    </div>
                    <div class="text-caption text--secondary">
                      {{ item.birthday }}
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                :disabled="loadingShedule"
                class="ma-2"
                outlined
                color="primary"
                @click="startPolling"
              >
                Показать
              </v-btn>
            </v-col>
            <v-col style="color: #2196f3">
              Время обновления: {{ timeRefresh }}
            </v-col>
          </v-row>
        </v-form>
        <v-dialog
          v-model="medicineItem.modal"
          transition="dialog-top-transition"
          max-width="700"
        >
          <v-card class="rounded-xl">
            <v-toolbar color="grey lighten-1" class="mb-5">
              <v-row class="justify-space-between align-center">
                <v-col cols="auto">
                  <p class="ma-0">
                    {{ medicineItem["ФИО"] }}
                  </p></v-col
                >
                <v-col cols="auto">
                  <v-btn icon @click="medicineItem.modal = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn></v-col
                >
              </v-row>
            </v-toolbar>
            <v-card-text>
              <v-simple-table>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Специальность</td>
                    <td>{{ medicineItem.speciality }}</td>
                  </tr>
                  <tr>
                    <td>Значимый опыт работы</td>
                    <td>
                      {{ medicineItem.specExp }}
                    </td>
                  </tr>
                  <tr>
                    <td>Регалии врача</td>
                    <td>{{ medicineItem.regalia }}</td>
                  </tr>
                  <tr>
                    <td>Что лечит</td>
                    <td>
                      {{ medicineItem.whatCures }}
                    </td>
                  </tr>
                  <tr>
                    <td>Рейтинг Продокторова</td>
                    <td>{{ medicineItem.doctorsRating }}</td>
                  </tr>
                  <tr>
                    <td>С какого возраста принимает</td>
                    <td>{{ medicineItem.ageTake }}</td>
                  </tr>
                  <tr>
                    <td>Стаж работы(с)</td>
                    <td>{{ medicineItem.experience }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="pacientItem.modal"
          transition="dialog-top-transition"
          max-width="700"
        >
          <v-card class="rounded-xl">
            <v-toolbar color="grey lighten-1" class="mb-5">
              <v-row class="justify-space-between align-center">
                <v-col cols="auto">
                  <p class="ma-0">
                    {{ pacientItem.name }}
                  </p></v-col
                >
                <v-col cols="auto">
                  <v-btn icon @click="pacientItem.modal = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn></v-col
                >
              </v-row>
            </v-toolbar>
            <v-card-text>
              <v-simple-table>
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Телефон</td>
                    <td>
                      <a :href="`tel:${pacientItem.phone}`">{{
                        pacientItem.phone
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>
                      <a :href="`mailto:${pacientItem.email}`">{{
                        pacientItem.email
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>День рождения</td>
                    <td>{{ pacientItem.birthday }}</td>
                  </tr>
                  <tr>
                    <td>Город проживания</td>
                    <td>
                      {{ pacientItem.city }}
                    </td>
                  </tr>
                  <tr>
                    <td>Адрес проживания</td>
                    <td>{{ pacientItem.addres }}</td>
                  </tr>
                  <tr>
                    <td>ФИО представителя</td>
                    <td>{{ pacientItem.nameAgent }}</td>
                  </tr>
                  <tr>
                    <td>Телефон представителя</td>
                    <td>
                      <a :href="`tel:${pacientItem.phoneAgent}`">{{
                        pacientItem.phoneAgent
                      }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td>Email представителя</td>
                    <td>
                      <a :href="`mailto:${pacientItem.emailAgent}`">{{
                        pacientItem.emailAgent
                      }}</a>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-row v-if="loading == true">
          <v-col>
            <v-progress-linear
              color="primary"
              height="6"
              indeterminate
              rounded
            ></v-progress-linear>
          </v-col>
        </v-row>
        <v-row class="fill-height" v-if="isCalendar">
          <v-col>
            <v-sheet height="64">
              <v-toolbar flat>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon text @click="closeCalendar">x</v-btn>
              </v-toolbar>
            </v-sheet>
            <v-sheet :height="height - 100">
              <v-calendar
                v-if="focus"
                ref="calendar"
                v-model="focus"
                color="primary"
                :locale-first-day-of-year="1"
                locale="RU"
                :events="events"
                :event-color="getEventColor"
                :event-class="getEventClass"
                :type="type"
                :more="false"
                :first-interval="firstInterval"
                :interval-count="countInterval"
                :interval-minutes="15"
                :short-intervals="false"
                category-show-all
                :categories="categories"
                @click:event="getEvent"
              >
                <template v-slot:[`event`]="{ event }">
                  <p class="text-center">
                    {{ event.nameRu }}
                  </p>
                  <v-dialog
                    v-model="event.menu"
                    transition="dialog-top-transition"
                    max-width="800"
                  >
                    <v-card class="rounded-xl">
                      <v-toolbar color="grey lighten-1" class="mb-5">
                        <v-row class="justify-space-between align-center">
                          <v-col cols="auto">
                            <p class="ma-0">
                              {{ event.name }}
                            </p></v-col
                          >
                          <v-col cols="auto">
                            <v-btn icon @click="closeEvent(event)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn></v-col
                          >
                        </v-row>
                      </v-toolbar>
                      <v-card-text>
                        <template v-if="!event.isSlot">
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Врач</td>
                                <td>
                                  <v-chip
                                    @click="
                                      openMedicine(event.medicineNAME, 'table')
                                    "
                                  >
                                    {{ event.medicineNAME }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Специализация</td>
                                <td>{{ event.specialization }}</td>
                              </tr>
                              <tr>
                                <td>Филиал</td>
                                <td>{{ event.branch }}</td>
                              </tr>
                              <tr>
                                <td>Дата и время записи</td>
                                <td>
                                  <v-text-field
                                    type="datetime-local"
                                    v-model="event.start"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>Время приема</td>
                                <td>
                                  <v-text-field
                                    v-model="event.duree"
                                    type="number"
                                    suffix="мин."
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>ФИО пациента</td>
                                <td>
                                  <v-chip @click="openPacient(event, 'event')">
                                    {{ event.pacient }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Планируемая сумма</td>
                                <td>
                                  {{ event.sum }}
                                </td>
                              </tr>
                              <tr>
                                <td>Комментарий</td>
                                <td>
                                  {{ event.comments }}
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                          <v-row>
                            <v-col cols="6">
                              <v-btn
                                block
                                color="gray"
                                :disabled="loading"
                                @click="eventCanсel(event)"
                                >Отменить</v-btn
                              >
                            </v-col>
                            <v-col cols="6">
                              <v-btn
                                block
                                color="primary"
                                :disabled="loading"
                                @click="editEvent(event)"
                                >Изменить</v-btn
                              >
                            </v-col>
                          </v-row>
                        </template>
                        <template v-else>
                          <v-row>
                            <v-col>
                              <v-form>
                                <v-autocomplete
                                  class="mb-2"
                                  v-model="event.assignedID"
                                  :items="allMedicine"
                                  item-text="ФИО"
                                  item-value="Ид"
                                  label="Ответственный"
                                  outlined
                                  hide-details
                                  color="primary"
                                  placeholder="ФИО"
                                  no-data-text="Ничего не найдено"
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                    >
                                      {{ data.item.ФИО }}
                                    </v-chip>
                                  </template>
                                </v-autocomplete>
                                <v-autocomplete
                                  :items="services"
                                  v-model="event.service"
                                  outlined
                                  item-text="name"
                                  item-value="pl_exam_id"
                                  color="primary"
                                  label="Услуга"
                                  @input="getProductInfo(event)"
                                >
                                </v-autocomplete>
                                <v-textarea
                                  v-model="event.comments"
                                  label="Комментарий"
                                  color="primary"
                                  outlined
                                ></v-textarea>
                                <v-autocomplete
                                  class="mb-2"
                                  v-model="event.pacientID"
                                  :items="pacients"
                                  :search-input.sync="searchPacient"
                                  item-text="name"
                                  item-value="id"
                                  label="Пациент"
                                  outlined
                                  hide-details
                                  color="primary"
                                  clearable
                                  placeholder="ФИО или телефона"
                                  no-data-text="Ничего не найдено"
                                  @update:search-input="onInput"
                                >
                                  <template v-slot:selection="data">
                                    <v-chip
                                      v-bind="data.attrs"
                                      :input-value="data.selected"
                                      @click="openPacient(data.item)"
                                    >
                                      {{ data.item.name }}
                                    </v-chip>
                                  </template>
                                  <template v-slot:item="{ item }">
                                    <div>
                                      <strong>{{ item.name }}</strong>
                                      <div class="text-caption text--secondary">
                                        {{ item.phone }}
                                      </div>
                                      <div class="text-caption text--secondary">
                                        {{ item.birthday }}
                                      </div>
                                    </div>
                                  </template>
                                </v-autocomplete>
                                <template v-if="event.pacientID == 1">
                                  <v-sheet border rounded="xl" class="pa-2">
                                    <v-btn-toggle
                                      v-model="event.male"
                                      mandatory
                                      color="primary"
                                      class="mb-4"
                                    >
                                      <v-btn value="0">Мужчина</v-btn>
                                      <v-btn value="1">Женщина</v-btn>
                                    </v-btn-toggle>
                                    <v-text-field
                                      v-model="event.pacientlastName"
                                      outlined
                                      label="Фамилия пациента"
                                      color="primary"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      v-model="event.pacientName"
                                      outlined
                                      label="Имя пациента"
                                      color="primary"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      v-model="event.pacientSecondName"
                                      outlined
                                      label="Отчество пациента"
                                      color="primary"
                                    >
                                    </v-text-field>
                                    <v-menu
                                      ref="birthsdayMenu"
                                      v-model="event.dateMenu"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-text-field
                                          v-model="event.pacientBirthsday"
                                          label="Дата рождения"
                                          prepend-inner-icon="mdi-calendar"
                                          readonly
                                          outlined
                                          color="primary"
                                          v-bind="attrs"
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="event.pacientBirthsday"
                                        locale="ru-RU"
                                        :first-day-of-week="1"
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="event.dateMenu = false"
                                        >
                                          Отмена
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="
                                            $refs.birthsdayMenu.save(
                                              event.pacientBirthsday
                                            )
                                          "
                                        >
                                          Сохранить
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                    <v-text-field
                                      v-model="event.pacientPhone"
                                      label="Телефон пациента"
                                      type="tel"
                                      outlined
                                      color="primary"
                                    ></v-text-field>
                                    <v-text-field
                                      v-model="event.pacientEmail"
                                      label="Email пациента"
                                      type="email"
                                      outlined
                                      color="primary"
                                    ></v-text-field>
                                    <v-text-field
                                      v-model="event.pacientAddress"
                                      label="Адрес проживания"
                                      outlined
                                      color="primary"
                                    ></v-text-field>
                                  </v-sheet>
                                </template>
                                <v-btn
                                  color="primary"
                                  block
                                  @click="eventAdd(event)"
                                  :disabled="loading"
                                  >Создать запись</v-btn
                                >
                              </v-form>
                            </v-col>
                            <v-col v-if="event.service">
                              <v-row>
                                <v-col cols="auto">
                                  <v-divider vertical></v-divider>
                                </v-col>
                                <v-col>
                                  <v-simple-table>
                                    <thead>
                                      <tr>
                                        <th></th>
                                        <th>Подробнее:</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Дата и время записи</td>
                                        <td>
                                          {{ formatedDateTime(event.start) }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Услуга</td>
                                        <td>{{ event.product }}</td>
                                      </tr>
                                      <tr>
                                        <td>Стоимость</td>
                                        <td>
                                          {{
                                            new Intl.NumberFormat(
                                              "ru-RU"
                                            ).format(event.sum)
                                          }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Время выполнения</td>
                                        <td>{{ event.duree }}</td>
                                      </tr>
                                      <tr>
                                        <td>Подготовка</td>
                                        <td>{{ event.podgotovka }}</td>
                                      </tr>
                                    </tbody></v-simple-table
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-slot:category="{ category }">
                  <v-btn
                    text
                    size="x-small"
                    @click="openMedicine(category, 'category')"
                    >{{ category }}</v-btn
                  >
                </template>
              </v-calendar>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col v-if="pacientEvents.length > 0">
            <v-sheet height="64">
              <v-toolbar flat>
                <v-btn
                  outlined
                  class="mr-4"
                  color="grey darken-2"
                  @click="setToday"
                >
                  Сегодня
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="prev">
                  <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="next">
                  <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon @click="closeViewDay" v-if="typePacient == 'day'"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :locale-first-day-of-year="1"
                locale="RU"
                :events="pacientEvents"
                :short-intervals="false"
                :more="false"
                :event-color="getEventColor"
                :type="typePacient"
                :first-interval="0"
                :interval-count="144"
                :interval-minutes="10"
                @click:more="viewDay"
                @click:date="viewDay"
                @click:event="getEventPacient"
              >
                <template v-slot:[`event`]="{ event }">
                  <p class="text-center">
                    {{ event.nameRu }}
                  </p>
                  <v-dialog
                    v-model="event.menu"
                    transition="dialog-top-transition"
                    max-width="600"
                  >
                    <v-card class="rounded-xl">
                      <v-toolbar color="grey lighten-1" class="mb-5">
                        <v-row class="justify-space-between align-center">
                          <v-col cols="auto">
                            <p class="ma-0">
                              {{ event.nameRu }}
                            </p></v-col
                          >
                          <v-col cols="auto">
                            <v-btn icon @click="closeEventPacient(event)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn></v-col
                          >
                        </v-row>
                      </v-toolbar>
                      <v-card-text>
                        <template>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Врач</td>
                                <td>
                                  <v-chip
                                    @click="
                                      openMedicine(event.medicineNAME, 'table')
                                    "
                                  >
                                    {{ event.medicineNAME }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Специализация</td>
                                <td>{{ event.specialization }}</td>
                              </tr>
                              <tr>
                                <td>Филиал</td>
                                <td>{{ event.branch }}</td>
                              </tr>
                              <tr>
                                <td>Дата и время записи</td>
                                <td>
                                  <v-text-field
                                    type="datetime-local"
                                    v-model="event.start"
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>Время приема</td>
                                <td>
                                  {{ event.duree }}
                                  <v-text-field
                                    v-model="event.duree"
                                    type="number"
                                    suffix="мин."
                                  ></v-text-field>
                                </td>
                              </tr>
                              <tr>
                                <td>ФИО пациента</td>
                                <td>
                                  <v-chip @click="openPacient(event, 'event')">
                                    {{ event.pacient }}
                                  </v-chip>
                                </td>
                              </tr>
                              <tr>
                                <td>Планируемая сумма</td>
                                <td>
                                  {{ event.sum }}
                                </td>
                              </tr>
                              <tr>
                                <td>Комментарий</td>
                                <td>
                                  <v-textarea
                                    v-model="event.comments"
                                    rows="1"
                                    auto-grow
                                  ></v-textarea>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                          <v-row>
                            <v-col cols="6">
                              <v-btn
                                block
                                color="gray"
                                :disabled="loading"
                                @click="eventCanсel(event)"
                                >Отменить</v-btn
                              >
                            </v-col>
                          </v-row>
                        </template>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </template>
              </v-calendar>
            </v-sheet>
          </v-col>
          <template v-else>
            <v-simple-table dense class="mt-10 schedule-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      rowspan="2"
                      class="header-cell date-column"
                      style="border-top-left-radius: 12px"
                    >
                      Дата
                    </th>
                    <th rowspan="2" class="header-cell doctor-column">Врач</th>
                    <th
                      v-for="(header, headerIndex) in dynamicHeaders"
                      :key="`header-${headerIndex}`"
                      colspan="4"
                      class="text-center filial-header"
                      :style="
                        headerIndex == dynamicHeaders.length - 1
                          ? `border-top-right-radius: 12px;`
                          : ''
                      "
                    >
                      {{ header.LABEL }}
                    </th>
                  </tr>
                  <tr>
                    <template v-for="(header, headerIndex) in dynamicHeaders">
                      <th
                        v-for="(timeSlot, timeIndex) in timeSlots"
                        :key="`subheader-${headerIndex}-${timeIndex}`"
                        class="text-center time-slot-header"
                      >
                        {{ timeSlot }}
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(date, dateIndex) in scheduleTest">
                    <tr
                      v-for="(doctor, doctorIndex) in date.doctors"
                      :key="`row-${dateIndex}-${doctorIndex}`"
                    >
                      <td
                        :style="
                          dateIndex == scheduleTest.length - 1
                            ? `border-bottom-left-radius: 12px;`
                            : ''
                        "
                        v-if="doctorIndex === 0"
                        :rowspan="date.doctors.length"
                        class="date-cell"
                      >
                        {{ date.date }}
                      </td>

                      <td
                        class="doctor-cell"
                        @click="openMedicine(doctor.name, 'category')"
                      >
                        {{ doctor.name }}
                      </td>

                      <template v-for="(filial, filialIndex) in doctor.filials">
                        <td
                          v-for="(time, timeIndex) in filial.times"
                          :key="`data-${filialIndex}-${timeIndex}`"
                          class="text-center data-cell"
                          :class="{
                            'filial-start': timeIndex === 0,
                            'filial-end': timeIndex === filial.times.length - 1,
                          }"
                          :style="
                            dateIndex == scheduleTest.length - 1 &&
                            filialIndex == doctor.filials.length - 1 &&
                            timeIndex == filial.times.length - 1 &&
                            doctorIndex == date.doctors.length - 1
                              ? `border-bottom-right-radius: 12px;`
                              : ''
                          "
                        >
                          <v-btn
                            :class="`${time?.color}`"
                            icon
                            :disabled="time.events.length == 0"
                            text
                            @click="openCalendar(time)"
                          >
                            {{ time.numFree }}
                          </v-btn>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <template v-for="row in schedule">
                    <v-col cols="12" :key="row.title">
                      <p class="mb-0 mt-6">{{ row.title }}</p>
                      <v-simple-table dense class="mt-0">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                class="text-center"
                                v-for="date in dateHeaders"
                                :key="date"
                              >
                                {{ date }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in row.items"
                              :key="`${row.title}/${item.time}`"
                            >
                              <td class="text-right">{{ item.time }}</td>
                              <td
                                class="text-center"
                                v-for="date in dateHeaders"
                                :key="date"
                              >
                                <v-btn
                                  :class="`${
                                    getObjectByDate(date, item.date)?.color
                                  }`"
                                  icon
                                  :disabled="!getObjectByDate(date, item.date)"
                                  text
                                  @click="
                                    openCalendar(
                                      getObjectByDate(date, item.date)
                                    )
                                  "
                                >
                                  {{
                                    getObjectByDate(date, item.date)
                                      ? getObjectByDate(date, item.date).numFree
                                      : ""
                                  }}
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col style="justify-items: center">
            <h1 style="color: red">У вас нет доступа к календарю!</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";

//TODO сделать занятость на 30 минут вперед по умолчанию
//TODO сделать обязательность полей формы записи
//TODO сделать возможность редактировать дату записи внутри записи

export default {
  name: "App",
  data: () => ({
    height: "",
    isTrue: false,
    typePacient: "month",
    focus: "",
    intervalId: null,
    medicineItem: {},
    pacientItem: {},
    isCalendar: false,
    timeRefresh: "",
    modal: false,
    timeoutID: null,
    loadingShedule: false,
    loadingSearch: false,
    searchPacient: "",
    pacientID: "",
    pacients: [{ name: "Создать нового", id: 1 }],
    selectedPacient: "",
    menu: false,
    normalDates: [],
    selectModal: "",
    modals: [],
    allModals: [],
    medicines: [],
    selectMedicine: [],
    branch: [],
    eventBranch: [],
    selectBranch: "",
    status: [
      {
        TITLE: "Действующая запись",
        ID: "0",
      },
      {
        TITLE: "Запись удалена",
        ID: "1",
      },
      {
        TITLE: "Запись изменена",
        ID: "2",
      },
      {
        TITLE: "Запись перенесена",
        ID: "3",
      },
    ],
    selectStatus: "",
    newFunc: false,
    loading: false,
    type: "category",
    selectedEvent: {},
    firstInterval: 69,
    countInterval: 13,
    duree: 30,
    events: [],
    categories: [],
    items: [],
    dateHeaders: [],
    headers: [],
    dynamicHeaders: [], // Динамические заголовки филиалов
    timeSlots: ["8-12", "12-15", "15-18", "18-21"],
    scheduleTest: [],
    schedule: [],
    services: [],
    products: [],
    pacientEvents: [],
    today: null,
    allMedicine: [],
    url: "https://msch168.bitrix24.ru/rest/8/2g94jhwiui7vlvbc/",
  }),
  computed: {
    // Можно добавить computed свойство для сортировки филиалов, если нужно
    sortedBranches() {
      return [...this.branch].sort((a, b) => a.LABEL.localeCompare(b.LABEL));
    },
  },
  methods: {
    getDoctorFilialTimes(doctor, branchId) {
      const filial = doctor.filials.find((f) => f.branchId === branchId);
      return filial ? filial.times : Array(4).fill(null); // 4 - количество временных слотов
    },
    updateDynamicHeaders() {
      try {
        // Формируем заголовки на основе выбранных филиалов
        if (this.selectBranch && this.selectBranch.length > 0) {
          // Если есть выбранные филиалы - показываем только их
          this.dynamicHeaders = this.branch.filter((branch) =>
            this.selectBranch.includes(branch.FM_INTORG_ID)
          );
        } else if (this.eventBranch && this.eventBranch.length > 0) {
          console.log(this.branch);
          console.log(this.eventBranch);
          // Если есть выбранные филиалы - показываем только их
          this.dynamicHeaders = this.branch.filter((branch) =>
            this.eventBranch.includes(branch.FM_INTORG_ID)
          );
        } else {
          // Если нет выбранных филиалов - показываем все
          this.dynamicHeaders = [...this.branch];
        }

        console.log("Dynamic headers updated:", this.dynamicHeaders);
      } catch (error) {
        console.error("Error updating dynamic headers:", error);
      }
    },
    async todayWeek() {
      try {
        this.today = new Date();

        this.dateHeaders = [];

        for (let i = 1; i < 8; i++) {
          let tomorrow = new Date(this.today);
          tomorrow.setDate(tomorrow.getDate() + i);
          this.dateHeaders.push(`${tomorrow.toLocaleDateString("ru-RU")}`);
        }
        this.startPolling();
      } catch (error) {
        console.log({ error });
      }
    },
    async prevWeeks() {
      try {
        let nextWeekStart = new Date(this.today); // Начало следующей недели
        nextWeekStart.setDate(this.today.getDate() - this.today.getDay() - 6); // Понедельник следующей недели

        this.dateHeaders = []; // Массив для хранения дат
        this.today = nextWeekStart;

        for (let i = 0; i < 7; i++) {
          let day = new Date(nextWeekStart);
          day.setDate(nextWeekStart.getDate() + i); // Добавляем дни к понедельнику
          this.dateHeaders.push(`${day.toLocaleDateString("ru-RU")}`); // Форматируем дату
        }
        this.startPolling();
      } catch (error) {
        console.log({ error });
      }
    },
    async nextWeeks() {
      try {
        let nextWeekStart = new Date(this.today); // Начало следующей недели
        nextWeekStart.setDate(
          this.today.getDate() + (7 - this.today.getDay() + 1)
        ); // Понедельник следующей недели
        this.today = nextWeekStart;
        this.dateHeaders = [];

        for (let i = 0; i < 7; i++) {
          let day = new Date(nextWeekStart);
          day.setDate(nextWeekStart.getDate() + i); // Добавляем дни к понедельнику
          this.dateHeaders.push(`${day.toLocaleDateString("ru-RU")}`); // Форматируем дату
        }
        this.startPolling();
      } catch (error) {
        console.log({ error });
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.typePacient = "day";
    },
    closeViewDay() {
      this.typePacient = "month";
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    onInput(searchPacient) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      if (this.searchPacient.length < 3) {
        // this.pacients = [];
        return;
      }

      this.timeoutId = setTimeout(() => {
        this.getPacient(searchPacient);
      }, 1500);
    },
    getEventClass(e) {
      return e.event.isOpen == 0 || !e.event.isOpen
        ? ""
        : "non-clickable-event"; // Класс для не кликабельных событий
    },
    async startPolling() {
      try {
        this.stopPolling();
        this.getSchedule();
        //await this.getSchedule(); // Загружаем события сразу
        this.intervalId = setInterval(this.getSchedule, 30000); // Обновляем каждые 30 секунд
        //  console.log(this.intervalId);
      } catch (error) {
        console.log({ error });
      }
    },
    // Добавляем метод для принудительного обновления заголовков
    forceUpdateHeaders() {
      this.$nextTick(() => {
        this.updateDynamicHeaders();
      });
    },
    async openMedicine(name, type) {
      // console.log({ name });
      // console.log(this.medicines);
      if (type == "category") {
        const medicine = this.medicines.findIndex(
          (e) => e["shortName"] == name
        );
        // console.log({ medicine });
        this.medicineItem = this.medicines[medicine];
      } else if (type == "table") {
        const medicine = this.medicines.findIndex((e) => e["ФИО"] == name);
        // console.log({ medicine });
        this.medicineItem = this.medicines[medicine];
      } else {
        this.medicineItem = name;
      }
      // console.log(this.medicineItem);
      const medicineCRM = await axios.post(this.url + "crm.item.get", {
        entityTypeId: 1050,
        id: this.medicineItem["IDB24"],
      });
      //console.log({ medicineCRM });
      this.medicineItem.speciality =
        medicineCRM.data.result.item.ufCrm12_1734612620557;
      this.medicineItem.specExp =
        medicineCRM.data.result.item.ufCrm12_1734612474;
      this.medicineItem.regalia =
        medicineCRM.data.result.item.ufCrm12_1734612498;
      this.medicineItem.whatCures =
        medicineCRM.data.result.item.ufCrm12_1734612512;
      this.medicineItem.doctorsRating =
        medicineCRM.data.result.item.ufCrm12_1734612526;
      this.medicineItem.ageTake =
        medicineCRM.data.result.item.ufCrm12_1735046188;
      this.medicineItem.experience =
        medicineCRM.data.result.item.ufCrm12_1735046223;
      this.medicineItem.modal = true;
    },
    async openCalendar(item) {
      this.focus = item.dateCalendar;
      this.firstInterval = item.firstInterval;
      this.countInterval = item.countInterval;
      this.events = item.events;
      this.categories = item.categories;
      this.isCalendar = true;

      // console.log(item);
    },
    closeCalendar() {
      this.isCalendar = false;
      this.events = [];
    },
    async openPacient(item, type = "pacient") {
      if (type == "event") {
        // console.log({ item });
        const response = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getPacients.php",
          {
            params: { search: item.pacient },
          }
        );
        // console.log({ response });
        this.pacientItem = {
          name: `${response.data.pacients[0].NOM} ${response.data.pacients[0].PRENOM} ${response.data.pacients[0].PATRONYME}`,
          id: response.data.pacients[0].PATIENTS_ID,
          birthday: response.data.pacients[0].NE_LE.split(" ")[0],
          phone: response.data.pacients[0].MOBIL_TELEFON,
          email: response.data.pacients[0].E_MAIL,
          male: response.data.pacients[0].POL == 1 ? "Муж" : "Жен",
          modal: false,
          emailAgent: response.data.pacients[0]["email представителя"],
          city: response.data.pacients[0]["Город по прописке"],
          addres: response.data.pacients[0]["адрес фактический"],
          nameAgent: `${response.data.pacients[0]["фамилия представителя"]} ${response.data.pacients[0]["имя представителя"]} ${response.data.pacients[0]["отчество представителя"]}`,
          phoneAgent: response.data.pacients[0]["телефон представителя"],
        };
        this.pacientItem.modal = true;
      } else {
        this.pacientItem = item;
        this.pacientItem.modal = true;
      }
    },
    remove(item, type) {
      if (type == "medicine") {
        const index = this.selectMedicine.indexOf(item["Ид"]);
        if (index >= 0) this.selectMedicine.splice(index, 1);
      } else if (type == "pacient") {
        this.selectedPacient = "";
      } else {
        const index = this.selectModal.indexOf(item.title);
        if (index >= 0) this.selectModal.splice(index, 1);
      }
    },
    async getPacient(searchPacient) {
      try {
        this.pacients = [{ name: "Создать нового", id: 1 }];
        // console.log(searchPacient);
        const response = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getPacients.php",
          {
            params: { search: searchPacient },
          }
        );
        // console.log({ response });
        for (const pacient of response.data.pacients) {
          this.pacients.push({
            name: `${pacient.NOM} ${pacient.PRENOM} ${pacient.PATRONYME}`,
            id: pacient.PATIENTS_ID,
            birthday: pacient.NE_LE.split(" ")[0],
            phone: pacient.MOBIL_TELEFON,
            email: pacient.E_MAIL,
            male: pacient.POL == 1 ? "Муж" : "Жен",
            modal: false,
            emailAgent: pacient["email представителя"],
            city: pacient["Город по прописке"],
            addres: pacient["адрес фактический"],
            nameAgent: `${pacient["фамилия представителя"]} ${pacient["имя представителя"]} ${pacient["отчество представителя"]}`,
            phoneAgent: pacient["телефон представителя"],
          });
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
        this.pacients = [];
      }
    },
    async getMedicine() {
      try {
        this.medicineIds = [];
        let isTrue = false;
        let elementID = 0;
        while (!isTrue) {
          const medicines = await axios.post(this.url + "crm.item.list", {
            entityTypeId: 1050,
            filter: {
              ">id": elementID,
            },
            select: ["*"],
            start: -1,
          });
          //   console.log(medicines.data.result.items);
          if (medicines.data.result.items.length > 0) {
            for (const medicine of medicines.data.result.items) {
              elementID = medicine.id;
              this.medicines.push({
                id: medicine.id,
                medicineId: medicine.ufCrm12_1734612598371,
                title: medicine.title,
                modal: false,
                speciality: medicine.ufCrm12_1734612620557,
                specExp: medicine.ufCrm12_1734612474,
                regalia: medicine.ufCrm12_1734612498,
                whatCures: medicine.ufCrm12_1734612512,
                doctorsRating: medicine.ufCrm12_1734612526,
                ageTake: medicine.ufCrm12_1735046188,
                experience: medicine.ufCrm12_1735046223,
              });
            }
            // console.log(this.medicines);
          } else {
            isTrue = true;
          }
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async getServices(medicineID) {
      try {
        // console.log({ medicineID });
        this.services = [];
        const services = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getServiceType.php",
          {
            params: {
              id: medicineID,
            },
          }
        );

        console.log(services.data.services);
        const servicesData = [];
        for (const service of services.data.services) {
          servicesData.push({
            name: `${service.name} (${service.duree})`,
            duree: service.duree,
            MEDECINS_ID: service.MEDECINS_ID,
            PL_SUBJ_ID: service.PL_SUBJ_ID,
            code: service.code,
            fm_serv_id: service.fm_serv_id,
            pl_exam_id: service.pl_exam_id,
          });
        }
        this.services = servicesData;
        console.log(this.services);
      } catch (error) {
        console.log({ error });
      }
    },
    async getMedicinesToModals() {
      try {
        this.loading = true;
        this.medicines = [];
        if (this.selectModal) {
          const modals = this.modals.filter(
            (e) => e.title == this.selectModal
          )[0];
          for (const modalIndex in modals.modals) {
            const plparamid = modals.modals[modalIndex];
            const getMedicineIDs = await axios.get(
              "https://spa-bitrix.ru/msch/calendar/hook/getMedicineIDs.php",
              {
                params: {
                  plparamid,
                },
              }
            );
            //console.log({ getMedicineIDs });

            for (const medicine of getMedicineIDs.data.medicineIDs) {
              const index = this.medicines.findIndex(
                (e) => e["Ид"] == medicine["Ид"]
              );
              if (index < 0) {
                this.medicines.push(medicine);
              }
            }
          }
        }
        this.medicines.sort((a, b) => a["ФИО"].localeCompare(b["ФИО"]));
        // console.log(this.medicines);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getModals() {
      try {
        const response = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getModal.php"
        );
        this.allModals = response.data.modals; // Сохраняем в кэш
        this.filterModalsByBranch(); // Применяем текущую фильтрацию
      } catch (error) {
        console.log({ error });
      }
    },
    formatDateToKey(date) {
      const [day, month, year] = date.split(".");
      return `${year}-${month}-${day}`;
    },
    getObjectByDate(date, objects) {
      const dateKey = this.formatDateToKey(date);
      return objects[dateKey];
    },
    formatTime(time) {
      const timeString = String(time).padStart(4, "0"); // Добавляем ведущие нули, если нужно (830 -> 0830)
      return `${timeString.slice(0, 2)}:${timeString.slice(2)}`; // Разделяем на часы и минуты
    },
    async getSchedule() {
      try {
        this.eventBranch = [];
        this.loadingShedule = true;
        if (this.selectedPacient) {
          this.schedule = [];
          const response = await axios.get(
            "https://spa-bitrix.ru/msch/calendar/hook/getShedulePacients.php",
            {
              params: { id: this.selectedPacient },
            }
          );
          // console.log({ response });
          const pacientEvents = [];
          for (const item of response.data.plannings) {
            const pacient = this.pacients.filter(
              (e) => e.id == this.selectedPacient
            )[0];
            /*const medicine = this.medicines.filter(
              (e) => e.ID == item.MEDECINS_ID
            );
            const assigned = this.medicines.filter(
              (e) => e.ID == item["Пользователь создавший запись"]
            );*/

            const date = item.DATE_CONS.split(" ")[0]; // Получаем дату без времени
            const formattedTime = this.formatTime(item.HEURE); // Преобразуем время в формат "HH:MM"
            const start = `${date}T${formattedTime}:00`;
            // console.log({ start });
            const dateTime = new Date(start);
            //  console.log({ dateTime });
            //  console.log(item.DUREE);
            dateTime.setMinutes(dateTime.getMinutes() + parseInt(item.DUREE));
            //   console.log({ dateTime });
            const end = dateTime.toISOString().slice(0, 19).replace("T", " ");
            //   console.log({ end });
            //   console.log({ item });

            const event = {
              start,
              end,
              color: "green",
              nameRu: item.NAME,
              id: item.PLANNING_ID,
              menu: false,
              dateMenu: false,
              duree: item.DUREE,
              titleName: item.NAME,
              medicine: "", //medicine.name,
              medicineID: item.MEDECINS_ID,
              branch: item["филиал"],
              pacientID: item.PATIENTS_ID,
              pacient: pacient.name,
              pacientPhone: pacient.phone,
              assignedID: item["Пользователь создавший запись"],
              assigned: "", //assigned.name,
              comments: item.COMMENTAIRE,
              sum: item["сумма оплаты"]
                ? item["сумма оплаты"]
                : item["Планируемая сумма"],
              planningID: item.PLANNING_ID,
              service: item.NAME,
            };
            pacientEvents.push(event);
          }
          this.pacientEvents = pacientEvents;
        } else {
          this.pacientEvents = [];
          // const scheduleArr = [];
          if (this.selectModal) {
            const modals = this.modals.filter(
              (e) => e.title == this.selectModal
            )[0];
            const plsubjs = [];
            const medecinsid = this.selectMedicine;
            // console.log({ medecinsid });

            for (const modalIndex in modals.modals) {
              console.log({ modalIndex });
              const indexBranch = this.eventBranch.indexOf(modalIndex);
              if (indexBranch == -1) {
                this.eventBranch.push(modalIndex);
              }

              // console.log(this.selectBranch);
              if (this.selectBranch.length > 0) {
                const isTrue = this.selectBranch.indexOf(modalIndex);
                // console.log({ isTrue });

                if (isTrue > -1) {
                  const plparamid = modals.modals[modalIndex];
                  const guideSchedule = await axios.get(
                    "https://spa-bitrix.ru/msch/calendar/hook/getGuideSchedule.php",
                    {
                      params: {
                        plparamid,
                        medecinsid,
                      },
                    }
                  );
                  console.log({ guideSchedule });
                  for (const item of guideSchedule.data.guideSchedule) {
                    plsubjs.push({
                      branch: modalIndex,
                      plsubjid: item.PL_SUBJ_ID,
                      start: this.dateHeaders[0],
                      end: this.dateHeaders[this.dateHeaders.length - 1],
                    });
                  }
                }
              } else {
                const plparamid = modals.modals[modalIndex];
                // console.log({ medecinsid });
                const guideSchedule = await axios.get(
                  "https://spa-bitrix.ru/msch/calendar/hook/getGuideSchedule.php",
                  {
                    params: {
                      plparamid,
                      medecinsid,
                    },
                  }
                );
                console.log({ guideSchedule });
                for (const item of guideSchedule.data.guideSchedule) {
                  plsubjs.push({
                    branch: modalIndex,
                    plsubjid: item.PL_SUBJ_ID,
                    start: this.dateHeaders[0],
                    end: this.dateHeaders[this.dateHeaders.length - 1],
                  });
                }
              }
            }
            const schedules = await axios.get(
              "https://spa-bitrix.ru/msch/calendar/hook/getShedule.php",
              {
                params: {
                  plsubjid: plsubjs,
                  status: this.selectStatus,
                },
              }
            );
            console.log({ schedules });

            this.scheduleTest = schedules.data;

            this.schedule = schedules.data.schedule;
            console.log(this.schedule, "schedule");

            // ВАЖНО: Обновляем заголовки после получения данных
            this.updateDynamicHeaders();

            const now = new Date();
            const hours = now.getHours().toString().padStart(2, "0"); // Добавляем ведущий ноль, если нужно
            const minutes = now.getMinutes().toString().padStart(2, "0"); // Добавляем ведущий ноль, если нужно
            const seconds = now.getSeconds().toString().padStart(2, "0"); // Добавляем ведущий ноль, если нужно
            this.timeRefresh = `${hours}:${minutes}:${seconds}`;
          } else {
            alert("Вы не выбрали специализацию!");
            await this.stopPolling();
          }
        }
        this.loadingShedule = false;
      } catch (error) {
        console.log({ error });
      }
    },
    getEventPacient(e) {
      e.event.menu = !e.event.menu;
    },
    closeEventPacient(e) {
      e.menu = !e.menu;
    },
    async eventCanсel(e, type = "cancel") {
      try {
        if (type == "cancel") this.loading = true;
        console.log(e);
        await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/canceledEvent.php",
          {
            params: {
              planning_id: e.planningID,
            },
          }
        );
        e.menu = !e.menu;
        await this.getSchedule();
        await this.closeEvent(e);
        this.closeCalendar();
        if (type == "cancel") this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async getEvent(e) {
      console.log(e.event);
      if (e.event.busy == "1") {
        const planning = await axios.get(
          "https://spa-bitrix.ru/webhooks/msch-168/getID.php",
          {
            params: {
              method: "getPlannigId",
              id: e.event.planningID,
            },
          }
        );
        console.log({ planning });
        e.event.name = planning.data[0].NAME;
        e.event.comments = planning.data[0].COMMENTAIRE;
        e.event.assignedID = planning.data[0]["Пользователь создавший запись"];
        e.event.sum = planning.data[0]["Планируемая сумма"].split(".")[0];
        e.event.service = planning.data[0]["PL_EXAM_ID"];
        e.event.assignedID = planning.data[0]["Пользователь создавший запись"];
        e.event.newEnd = "";
      } else {
        await this.getProducts(e.event.medicineID, e.event.branch);
        e.event.isOpen = 1;
        // console.log(e);
        const date = new Date(e.event.date); // Указанная дата
        const startOfYear = new Date(date.getFullYear(), 0, 1); // Начало года (1 января)
        // Вычисляем разницу в миллисекундах
        const diffInMilliseconds = date - startOfYear;
        // Преобразуем разницу в дни
        const diffInDays = Math.floor(
          diffInMilliseconds / (1000 * 60 * 60 * 24)
        );
        console.log(e.event.time); // Вывод: 71
        const openEvent = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/reserve.php",
          {
            params: {
              id: `${e.event.id};${diffInDays};${e.event.time.split(":")[0]};${
                e.event.time.split(":")[1]
              };${e.event.medicineID}`,
              value: 1,
            },
          }
        );
        console.log(openEvent);
      }
      e.event.menu = !e.event.menu;
    },
    async closeEvent(e) {
      //console.log({ e });
      e.menu = !e.menu;
      e.isOpen = 0;
      const date = new Date(e.date); // Указанная дата
      const startOfYear = new Date(date.getFullYear(), 0, 1); // Начало года (1 января)
      // Вычисляем разницу в миллисекундах
      const diffInMilliseconds = date - startOfYear;
      // Преобразуем разницу в дни
      const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
      console.log(diffInDays); // Вывод: 71
      const closeEvent = await axios.get(
        "https://spa-bitrix.ru/msch/calendar/hook/reserve.php",
        {
          params: {
            id: `${e.id};${diffInDays};${e.time.split(":")[0]};${
              e.time.split(":")[1]
            };${e.medicineID}`,
            value: 0,
          },
        }
      );
      console.log(closeEvent);
    },
    getEventColor(event) {
      // console.log({ event });
      if (event.isOpen == 1) {
        return "orange";
      }
      return event.color;
    },
    async stopPolling() {
      try {
        if (this.intervalId) {
          await clearInterval(this.intervalId);
          this.intervalId = null;
        }
      } catch (error) {
        console.log({ error });
      }
    },
    addMinutes(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },
    getProductInfo(event) {
      //получаем инфо по виду услуги(кабинет, время выполнения)
      const service = this.services.filter(
        (e) => e.pl_exam_id == event.service
      )[0];
      console.log({ service });
      event.duree = service.duree; //+
      /*const products = this.products.filter(
        (e) => e.FM_SERV_ID == service.fm_serv_id
      )[0];*/
      //console.log({ products });

      event.sum = service.sum;
      event.podgotovka = service.podgotovka;
      event.product = service.name;
      console.log(event.start);
      console.log(event.duree);

      let oldDate = new Date(event.start);
      let newDate = this.addMinutes(oldDate, event.duree);

      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
      const day = String(newDate.getDate()).padStart(2, "0");
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");
      const seconds = String(newDate.getSeconds()).padStart(2, "0");

      event.end = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      console.log(event.end); // Вывод: "2025-03-13T16:50:00"
      /*const date = new Date(event.start + "Z");
      const minutesTo = date.getMinutes() + event.duree.padStart(2, "0");
      console.log(minutesTo);
      date.setMinutes(minutesTo);

      // Форматируем дату вручную, чтобы избежать перевода в UTC
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      event.end = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      console.log(event.end); // Вывод: "2025-03-13T16:50:00"
      console.log({ event });*/
      console.log({ event });
    },
    isOverlapping(event1, event2, type = "add") {
      console.log({ type });
      console.log({ event1 });
      console.log({ event2 });

      const start1 = new Date(
        type == "add" ? event1.start : event1.oldStart
      ).getTime();
      const end1 = new Date(event1.end).getTime();
      const start2 = new Date(event2.start).getTime();
      const end2 = new Date(
        type == "add" ? event2.end : event2.newEnd
      ).getTime();

      return start1 < end2 && end1 > start2;
    },
    async eventAdd(event, type = "add") {
      if (type == "add") this.loading = true;
      //проверяем, не попадает ли эвент на занятые эвенты?
      const isBusy = this.events.some(
        (e) => e.busy === "1" && this.isOverlapping(e, event, type)
      );
      console.log({ isBusy });
      if (!isBusy) {
        //вносим все в эвент
        let pacientID = event.pacientID;
        if (type == "add") {
          if (event.pacientID == 1) {
            const date = new Date(event.pacientBirthsday);

            const day = String(date.getDate()).padStart(2, "0"); // Получаем день и добавляем ведущий ноль, если нужно
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Получаем месяц (начинается с 0, поэтому +1) и добавляем ведущий ноль
            const year = date.getFullYear(); // Получаем год

            const formattedDate = `${day}.${month}.${year}`;
            const paramsClient = {
              email: event.pacientEmail,
              name: event.pacientName,
              surname: event.pacientlastName,
              patronymic: event.pacientSecondName,
              birthday: formattedDate,
              telephone: event.pacientPhone,
              address: event.pacientAddress,
              male: event.male,
            };
            const pacient = await axios.get(
              "https://spa-bitrix.ru/msch/calendar/hook/pacientAdd.php",
              {
                params: paramsClient,
              }
            );
            console.log({ pacient });
            console.log({ paramsClient });

            pacientID = pacient.data[0];
          } else {
            const pacient = this.pacients.filter(
              (e) => e.id == event.pacientID
            )[0];
            console.log({ pacient });
            event.pacientAddress = pacient.addres;
            event.pacientBirthsday = pacient.birthday;
            event.pacientEmail = pacient.email;
            event.pacientPhone = pacient.phone;
            event.pacientName = pacient.name.split(" ")[1];
            event.pacientSecondName = pacient.name.split(" ")[2];
            event.pacientlastName = pacient.name.split(" ")[0];
          }
        }
        const dateStart = new Date(event.start);

        const day = String(dateStart.getDate()).padStart(2, "0");
        const month = String(dateStart.getMonth() + 1).padStart(2, "0");
        const year = dateStart.getFullYear();

        const hours = String(dateStart.getHours()).padStart(2, "0");
        const minutes = String(dateStart.getMinutes()).padStart(2, "0");
        const seconds = String(dateStart.getSeconds()).padStart(2, "0");

        const formattedDate = `${day}.${month}.${year}`;
        const formattedDateTimeStart = `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
        const dateEnd = new Date(type == "add" ? event.end : event.newEnd);

        const hoursEnd = String(dateEnd.getHours()).padStart(2, "0");
        const minutesEnd = String(dateEnd.getMinutes()).padStart(2, "0");
        const secondsEnd = String(dateEnd.getSeconds()).padStart(2, "0");
        const time =
          type == "add"
            ? event.time
            : event.start.split("T")[1].split(":")[0] +
              event.start.split("T")[1].split(":")[1];
        const formattedDateTimeEnd = `${day}.${month}.${year} ${hoursEnd}:${minutesEnd}:${secondsEnd}`;
        //получаем по выбранному виду все услуги
        const paramEvent = {
          pl_subj_id: event.plsubjid,
          date: formattedDate,
          heure: time.replace(/[^\w\s]|_/g, ""),
          duree: event.duree,
          patients_id: pacientID,
          nom: event.pacientlastName,
          prenom: event.pacientName,
          patronyme: event.pacientSecondName,
          pl_exam_id: event.service,
          date_start: formattedDateTimeStart,
          date_end: formattedDateTimeEnd,
          doc: event.comments,
          assignedID: event.assignedID,
          // cabinet: cabinet,
        };
        console.log({ paramEvent });
        await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/eventAdd.php",
          {
            params: paramEvent,
          }
        );
        await this.getSchedule();
        await this.closeEvent(event);
        this.closeCalendar();

        return 1;
      } else {
        alert(
          "Выбранная услуга не помещается в расписание врача на этот день! выберите другое время для записи!"
        );
      }
      if (type == "add") this.loading = false;
    },
    async editEvent(event) {
      try {
        console.log(event);
        this.loading = true;
        let oldDate = new Date(event.start);
        let newDate = this.addMinutes(oldDate, event.duree);

        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
        const day = String(newDate.getDate()).padStart(2, "0");
        const hours = String(newDate.getHours()).padStart(2, "0");
        const minutes = String(newDate.getMinutes()).padStart(2, "0");
        const seconds = String(newDate.getSeconds()).padStart(2, "0");

        event.newEnd = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        console.log(event.end); // Вывод: "2025-03-13T16:50:00"

        const res = await this.eventAdd(event, "edit");
        if (res == 1) {
          this.eventCanсel(event, "edit");
        }
        this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async getAllMedicine() {
      try {
        const medicines = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getAllMedicine.php"
        );
        // console.log({ medicines });
        this.allMedicine = medicines.data.medicines;
      } catch (error) {
        // console.log({ error });
      }
    },
    async getProducts(medecins, orgtype) {
      try {
        this.services = [];
        const services = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getProducts.php",
          {
            params: { medecins, orgtype },
          }
        );
        const servicesData = [];
        for (const service of services.data.products) {
          servicesData.push({
            name: `${service.LABEL} (${service.DUREE})`,
            duree: service.DUREE,
            MEDECINS_ID: medecins,
            podgotovka: service.podgotovka,
            sum: service.Cost,
            fm_serv_id: orgtype,
            pl_exam_id: service.PL_EXAM_ID,
          });
        }
        this.services = servicesData;
        console.log(this.services, "products");
      } catch (error) {
        console.log({ error });
      }
    },
    formatedDateTime(dateTime) {
      const date = new Date(dateTime); // Создаем объект Date

      // Форматируем дату
      const day = String(date.getDate()).padStart(2, "0"); // День (с ведущим нулем)
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяц (с ведущим нулем)
      const year = date.getFullYear(); // Год
      const hours = String(date.getHours()).padStart(2, "0"); // Часы (с ведущим нулем)
      const minutes = String(date.getMinutes()).padStart(2, "0"); // Минуты (с ведущим нулем)
      const seconds = String(date.getSeconds()).padStart(2, "0"); // Секунды (с ведущим нулем)

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    },
    async getBranch() {
      try {
        this.branch = [];
        /* const branch = await axios.get(
          "https://spa-bitrix.ru/msch/calendar/hook/getBranch.php"
        );
        console.log({ branch });*/
        this.branch = [
          { LABEL: "Арбузова 1/1", FM_INTORG_ID: "2278", CODE: "Арбузова 1/1" },
          { LABEL: "Коптюга 13", FM_INTORG_ID: "2300", CODE: "Коптюга 13" },
          { LABEL: "ВАСХНИЛ", FM_INTORG_ID: "2525", CODE: "ВАСХНИЛ" },
          { LABEL: "Новая заря", FM_INTORG_ID: "3155", CODE: "Новая заря" },
        ]; //branch.data;
        console.log(this.branch);
      } catch (error) {
        console.log({ error });
      }
    },
    async filterModalsByBranch(selectedBranches = null) {
      const branches = selectedBranches || this.selectBranch;

      // Если нет выбранных филиалов - показываем все
      if (!branches || branches.length === 0) {
        this.modals = [...this.allModals].sort((a, b) =>
          a.title.localeCompare(b.title)
        );
        return;
      }

      // Фильтруем из кэша
      const filteredModals = this.allModals.filter((modal) => {
        const modalBranchIds = Object.keys(modal.modals);
        return branches.some((selectedBranchId) =>
          modalBranchIds.includes(selectedBranchId.toString())
        );
      });

      this.modals = filteredModals.sort((a, b) =>
        a.title.localeCompare(b.title)
      );

      // Сбрасываем выбранную специализацию если она не доступна
      if (
        this.selectModal &&
        !this.modals.some((modal) => modal.title === this.selectModal)
      ) {
        this.selectModal = "";
        this.medicines = [];
      }
    },
  },
  watch: {
    selectBranch: {
      handler(newVal) {
        this.filterModalsByBranch(newVal);
        this.updateDynamicHeaders(); // Обновляем заголовки при изменении выбора филиалов
      },
      deep: true,
      immediate: false,
    },
    branch: {
      handler() {
        this.updateDynamicHeaders(); // Обновляем при изменении списка филиалов
      },
      deep: true,
      immediate: true,
    },
    scheduleTest: {
      handler() {
        this.$nextTick(() => {
          this.updateDynamicHeaders();
        });
      },
      deep: true,
      immediate: false,
    },
  },
  async mounted() {
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    const url = `https://${this.auth.DOMAIN}/rest/`;
    const user = await axios.post(url + "profile", {
      auth: this.auth.ACCESS_TOKEN,
    });
    console.log({ user });
    if (
      user.data.result.ADMIN ||
      user.data.result.ID == 250 ||
      user.data.result.ID == 430
    ) {
      this.isTrue = true;
    }
    this.height = window.innerHeight;
    this.isTrue = true;
    console.log(this.isTrue);
    this.loading = true;
    this.today = new Date();
    this.dateHeaders.push(`${this.today.toLocaleDateString("ru-RU")}`);
    for (let i = 1; i < 30; i++) {
      let tomorrow = new Date(this.today);
      tomorrow.setDate(tomorrow.getDate() + i);
      this.dateHeaders.push(`${tomorrow.toLocaleDateString("ru-RU")}`);
    }

    await this.getAllMedicine();
    await this.getModals();
    await this.getBranch();

    this.loading = false;
  },
};
</script>
<style>
/* Основные стили таблицы */
.schedule-table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

/* Общие стили ячеек */
.schedule-table th,
.schedule-table td {
  padding: 6px 4px;
  text-align: center;
}

/* Заголовки */
.header-cell {
  background-color: #e0e0e0;
  font-weight: bold;
  border: 1px solid #000 !important;
}

.filial-header {
  background-color: #bdbdbd;
  border: 1px solid #000 !important;
  font-weight: bold;
}

.time-slot-header {
  background-color: #eeeeee;
  border: 1px solid #000 !important;
  font-weight: 500;
}

/* Колонки */
.date-column {
  width: 100px;
}

.doctor-column {
  width: 180px;
}

/* Тело таблицы */
.date-cell {
  font-weight: bold;
  background-color: #f5f5f5;
  border: 1px solid #000 !important;
  vertical-align: middle;
}

.doctor-cell {
  border: 1px solid #000 !important;
  text-align: left;
  padding-left: 12px !important;
}

.data-cell {
  border-top: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
  min-width: 50px;
}

/* Выделение зон филиалов */
.filial-start {
  border-left: 1px solid #000 !important;
}

.filial-end {
  border-right: 1px solid #000 !important;
}

/* Вертикальные разделители между филиалами */
tr td:not(.filial-start) {
  border-left: none !important;
}

tr td:not(.filial-end) {
  border-right: none !important;
}

.v-calendar-category__column-header {
  display: flex;
  justify-content: center;
}
.non-clickable-event {
  pointer-events: none;
  opacity: 0.5;
}
</style>
